export default [{"url":"https://gdph-0.api.invexerp.io","name":"Branch 1","port":"5049","isStore":true,"isHQ":true}]